/**
 * Counsel attestation, Oct 8, 2026.
 * Each import or API key logs the agent id, timestamp, this version, and a record count.
 */

const ATTESTATION_VERSION = '2026-10-08';

const CSV_ATTESTATION = 'I state that everyone in this file is my current or past client, that I got their contact information while working with them (not purchased, rented, or scraped), that they\'d reasonably expect to hear from me, and that I\'m allowed to share it with Pacarion. I understand Pacarion LLC will email each person an invitation on my behalf, and that people who have unsubscribed won\'t be invited.';

const API_KEY_ATTESTATION = 'I\'ll only use this key to add my own clients who gave me their contact information while working with me, never purchased, rented, or scraped lists. I understand Pacarion LLC will email each person added an invitation on my behalf if I choose to send an invitation.';

function csvAttestationMissing(attested) {
  return attested !== true;
}

/** Rows actually written: created plus blank-field updates. Skips and errors are not counted. */
function acceptedImportCount(batch) {
  const created = Number(batch && batch.created_count) || 0;
  const updated = Number(batch && batch.updated_count) || 0;
  return created + updated;
}

function storedRecordCount(recordCount) {
  if (recordCount == null) return null;
  const count = Number(recordCount);
  return Number.isFinite(count) ? count : null;
}

function attestationEvent({
  agentId,
  actorUserId = null,
  recordCount = 0,
  kind,
  batchId = null,
  apiKeyId = null,
  now = new Date(),
}) {
  const attestedAt = now instanceof Date ? now.toISOString() : new Date(now).toISOString();
  return {
    agent_id: agentId,
    source: kind === 'api_key' ? 'api' : 'csv',
    action: 'attestation_recorded',
    batch_id: batchId || null,
    api_key_id: apiKeyId || null,
    actor_user_id: actorUserId || null,
    details: {
      attestation_version: ATTESTATION_VERSION,
      record_count: storedRecordCount(recordCount),
      attested_at: attestedAt,
      kind: kind || null,
    },
  };
}

export {
  ATTESTATION_VERSION,
  CSV_ATTESTATION,
  API_KEY_ATTESTATION,
  csvAttestationMissing,
  acceptedImportCount,
  attestationEvent,
};
